export const getIconTextStyle = (version) => version === 'secondary' ? 'group-data-primary:text-white' : 'text-secondary-text';
//# sourceMappingURL=getIconTextStyle.js.map